import { DynamicInputBase } from './dynamic-input-base';

export class DateInput extends DynamicInputBase<any> {
    controlType = 'date';
}
